import { Component, Input } from '@angular/core';
import { MonthViewDay } from 'calendar-utils';

@Component({
  selector: 'app-custom-week-header',
  template: './custom-week-header.component.html',
})
export class CustomWeekHeaderComponent {
	@Input() days: MonthViewDay[];
}

